import axios, { type AxiosError, type AxiosInstance, type AxiosResponse } from 'axios'
import { defineStore } from 'pinia'
import {
    type ProductMatrixResponse,
    type ProductStoreActions,
    type ProductStoreGetters,
    type ProductStoreState,
} from '@/types'
import { processApiError } from '@/utils'

const productApi: AxiosInstance = axios.create({
    baseURL: `${import.meta.env.VITE_API_HOSTNAME}/product/${import.meta.env.VITE_API_VERSION}`,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
})

export const useProductStore = defineStore<
    'product',
    ProductStoreState,
    ProductStoreGetters,
    ProductStoreActions
>('product', {
    state: (): ProductStoreState => ({
        offers: [],
    }),
    actions: {
        async getMatrix() {
            await productApi
                .get('/default-matrix')
                .then((response: AxiosResponse) => {
                    this.offers = (response.data as ProductMatrixResponse).data
                })
                .catch((error: AxiosError) => {
                    processApiError(error)
                })
        },
    },
})
